"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _Icon = require("../../../Icon");
var _Menu = require("../../../Menu");
var _ScrollSelector = require("../../../ScrollSelector");
var _DateTimePickers = require("../../DateTimePickers.labels");
var _hooks = require("../../../../hooks");
var _strings = require("../../../../utilities/strings");
var _TimePicker = _interopRequireDefault(require("../TimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MobileView = props => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    defaultHourOption,
    defaultMinuteOption,
    hourOptions,
    minutesOptions,
    onTimeChange
  } = props;
  const styles = (0, _TimePicker.default)(true, 'roundedRectangle');
  const getLabel = (0, _hooks.useLabels)({
    labels: _DateTimePickers.labels
  });
  const [isBoxAnimationComplete, setIsBoxAnimationComplete] = (0, _react.useState)(false);
  const [scrolledHour, setScrolledHour] = (0, _react.useState)(defaultHourOption.value);
  const [scrolledMinute, setScrolledMinute] = (0, _react.useState)(defaultMinuteOption.value);
  const btnProps = {
    view: 'text',
    color: 'basic',
    width: 65,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-TimePicker__anchor-btn'],
      children: [(0, _strings.padNumberWithPrefixZero)(defaultHourOption.value), ":", (0, _strings.padNumberWithPrefixZero)(defaultMinuteOption.value), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "Caret",
        width: 12,
        height: 12,
        fillColor: themeColors?.primary.main
      })]
    })
  };
  const handleConfirm = () => {
    onTimeChange(scrolledHour, scrolledMinute);
  };
  const handleBoxAnimationComplete = () => {
    setIsBoxAnimationComplete(true);
    setTimeout(() => {
      setIsBoxAnimationComplete(false);
    }, 1000);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-TimePicker'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
      btnProps: btnProps,
      defaultTitle: getLabel('choose_time'),
      isWithActionButtons: true,
      onConfirm: handleConfirm,
      onBoxAnimationComplete: handleBoxAnimationComplete,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-TimePicker__scroll-selector-container'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScrollSelector.ScrollSelector, {
          scrollOptions: minutesOptions,
          defaultOption: isBoxAnimationComplete ? defaultMinuteOption : undefined,
          onScrollValueChange: value => {
            setScrolledMinute(value);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScrollSelector.ScrollSelector, {
          scrollOptions: hourOptions,
          defaultOption: isBoxAnimationComplete ? defaultHourOption : undefined,
          onScrollValueChange: value => {
            setScrolledHour(value);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-TimePicker__scroll-selector-mask']
        })]
      })
    })
  });
};
exports.MobileView = MobileView;